<template>
  <div :class="`${noPadding ? 'py-0' : 'py-3'} w-full ${isLabelInFrontInput && 'mb-1 flex items-center space-x-2'}`">
    <label v-if="label" class="whitespace-nowrap text-sm font-medium not-italic text-gray-800"
      >{{ label }}<span v-if="required" class="text-orange-600 pl-0.5">*</span></label
    >
    <div :class="` relative mt-1 flex w-full flex-col justify-center`">
      <DxTextBox
        :class="`w-full border p-1 text-lg leading-normal ${
          isError ? 'border-error' : 'border-[#dee1e3]'
        } !important relative appearance-none bg-white text-left font-sans text-dark shadow-sm  outline-none focus:border-primary ${
          isSuccess ? 'mb-2 border-success' : ''
        }`"
        :mask="mask"
        :use-masked-value="useMaskValue"
        :show-mask-mode="showMaskMode"
        :mask-rules="maskRules"
        :input-attr="inputAttr"
        :mask-invalid-message="maskInvalidMessage"
        :show-clear-button="showClearButton"
        :value-change-event="valueChangeEvent"
        :value="value"
        :v-model:value="vModel"
        @value-changed="$emit('value-changed', $event)"
      />
    </div>
    <span v-if="isError" class="error-message text-sm text-error">{{ errorMessage }}</span>
    <span v-if="isSuccess" class="rounded-sm bg-success p-2 text-sm text-white">{{ successMessage }}</span>
  </div>
</template>

<script lang="ts">
import "devextreme/dist/css/dx.light.css";

import { DxTextBox } from "devextreme-vue/text-box";
import { defineComponent } from "vue";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
export default defineComponent({
  components: {
    DxTextBox,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    isLabelInFrontInput: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    successMessage: {
      type: String,
      default: "",
    },
    showClearButton: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: String,
      default: "",
    },
    useMaskValue: {
      type: String,
      default: "",
    },
    showMaskMode: {
      type: String,
      default: "",
    },
    vModel: {
      type: String,
      default: "",
    },
    valueChangeEvent: {
      type: String,
      default: "",
    },
    maskRules: {
      type: Object,
      default: () => ({}),
    },
    inputAttr: {
      type: Object,
      default: () => ({}),
    },
    maskInvalidMessage: {
      type: String,
      default: "",
    },
  },
  emits: ["value-changed"],
});
</script>

<style scoped>
.error-message {
  margin-top: 5rem;
}

#input:disabled {
  @apply cursor-not-allowed bg-gray-100;
}
</style>
